import { useSite } from '../lib/site-context.jsx';
import { paragraphsOf, shortDate } from '../lib/format.js';
import { EmptyState } from '../ui/ProjectCard.jsx';

export function Blog({ data }) {
  const { t } = useSite();
  const posts = data.posts || [];
  return (
    <>
      <section className="section page-head">
        <div className="wrap">
          <span className="section-eyebrow">{t('blog_eyebrow', 'Insights')}</span>
          <h1>{t('blog_heading', 'Market notes & insights')}</h1>
        </div>
      </section>
      <section className="section section-flush">
        <div className="wrap">
          {posts.length === 0
            ? <EmptyState>No posts published yet. Check back soon.</EmptyState>
            : (
              <div className="project-grid" id="blog-grid">
                {posts.map((p, i) => (
                  <a className="project-card post-card" key={p.slug} href={`/blog-post?slug=${encodeURIComponent(p.slug)}`}>
                    <div className="card-media">
                      {p.hero_image ? <img src={p.hero_image} alt="" loading={i < 3 ? 'eager' : 'lazy'} decoding="async" width="640" height="480" /> : <span className="card-initial" aria-hidden="true">{String(p.title || '?').charAt(0)}</span>}
                    </div>
                    <div className="card-body">
                      <h3>{p.title}</h3>
                      <div className="card-locality"><time dateTime={p.published_at}>{shortDate(p.published_at)}</time></div>
                      {p.body && <p className="card-excerpt">{paragraphsOf(p.body)[0]?.slice(0, 140)}{paragraphsOf(p.body)[0]?.length > 140 ? '…' : ''}</p>}
                    </div>
                  </a>
                ))}
              </div>
            )}
        </div>
      </section>
    </>
  );
}

export function BlogPost({ data }) {
  const post = data.post;
  if (!post) {
    return (
      <section className="section"><div className="wrap"><div className="empty-state"><h1>Not found</h1><p>We couldn&apos;t find that post.</p><a className="btn btn-outline btn-sm" href="/blog">Back to the blog</a></div></div></section>
    );
  }
  return (
    <article className="section post" id="blog-post-root">
      <div className="wrap narrow">
        <nav className="breadcrumb" aria-label="Breadcrumb"><a href="/">Home</a><span aria-hidden="true">›</span><a href="/blog">Blog</a><span aria-hidden="true">›</span><span aria-current="page">{post.title}</span></nav>
        {post.published_at && <span className="section-eyebrow"><time dateTime={post.published_at}>{shortDate(post.published_at)}</time></span>}
        <h1>{post.title}</h1>
        {post.hero_image && <img className="post-hero" src={post.hero_image} alt="" width="1200" height="675" decoding="async" />}
        <div className="prose">{paragraphsOf(post.body).map((para, i) => <p key={i}>{para}</p>)}</div>
        <p><a className="btn btn-outline btn-sm" href="/blog">← All posts</a></p>
      </div>
    </article>
  );
}
